export default "__VITE_ASSET__9uglk371__"